import { defineMessages } from 'react-intl';

export default defineMessages({
    twiaRegistrationInstructions: {
        id: 'agent.registration.views.twiaRegistrationInstructions',
        defaultMessage: 'All the steps required to register with TWIA must be completed during one internet session, including clicking “Submit” on the final screen. If you leave the session before submitting your request, your information will not be saved. Once you successfully complete all the steps, you will be presented with a confirmation that your registration request is complete and has been received by TWIA.'
    },
    tfpaRegistrationInstruction: {
        id: 'agent.registration.views.tfpaRegistrationInstructions',
        defaultMessage: 'All the steps required to register with TFPA must be completed during one internet session, including clicking "Submit" on the final screen. If you leave the session before submitting your request, your information will not be saved. Once you successfully complete all the steps, you will be presented with a confirmation that your registration request is complete and has been received by TFPA'
    },
    AgnecyInformation: {
        id: 'agent.registration.views.Agency Information',
        defaultMessage: 'Agency Information',
    },
    AgnecyName: {
        id: 'agent.registration.views.Agency Name',
        defaultMessage: 'Agency Name (As Registered with TDI)',
    },
    PrimaryLocationAddress: {
        id: 'agent.registration.views. agent.registration.Primary Location Address',
        defaultMessage: 'Primary Location Address (As Registered with TDI)',
    },
    AgencyAddress: {
        id: 'agent.registration.views. agent.registration.Agency Address',
        defaultMessage: 'Primary Location Address (As Registered with TDI)',
    },
    MailingAddressDifferent: {
        id: 'agent.registration.views.Different Mailing Address?',
        defaultMessage: 'Different Mailing Address?',
    },
    AddressLine1: {
        id: 'agent.registration.Address Line 1',
        defaultMessage: 'Address Line 1',
    },
    AddressLine2: {
        id: 'agent.registration.Address Line 2',
        defaultMessage: 'Address Line 2',
    },
    AddressLine3: {
        id: 'agent.registration.Address Line 3',
        defaultMessage: 'Address Line 3',
    },
    City: {
        id: 'agent.registration.City',
        defaultMessage: 'City',
    },
    PostalCode: {
        id: 'agent.registration.ZIP Code',
        defaultMessage: 'ZIP Code',
    },
    State: {
        id: 'agent.registration.State',
        defaultMessage: 'State',
    },
    AgencyContact: {
        id: 'agent.registration.Agency Contact',
        defaultMessage: 'Agency Contact',
    },
    FirstName: {
        id: 'agent.registration.First Name',
        defaultMessage: 'First Name',
    },
    LastName: {
        id: 'agent.registration.Last Name',
        defaultMessage: 'Last Name',
    },
    EOCoverageTitle: {
        id: 'agent.registration.views.EOCoverageTitle',
        defaultMessage: 'E&O Coverage',
    },
    EOCoverage: {
        id: 'agent.registration.views.EO Coverage',
        defaultMessage: 'E&O Coverage?',
    },
    EOIssuingCarrier: {
        id: 'agent.registration.views.Issuing Carrier',
        defaultMessage: 'Issuing Carrier',
    },
    EOLimits: {
        id: 'agent.registration.views.Limits',
        defaultMessage: 'Limits',
    },
    EOExpirationDate: {
        id: 'agent.registration.views.Expiration Date',
        defaultMessage: 'Expiration Date',
    },
    AgencyInformationLegal: {
        id: 'agent.registration.views.AgencyInformationLegal',
        defaultMessage: 'Note: Policy documents and commission statements will be available online.',
    },
    EOExpirationDateValidationMessage: {
        id: 'agent.registration.views.EOExpirationDateValidationMessage',
        defaultMessage: 'EO Expiration Date must be a date in future.',
    },
    EmailValidationMessage: {
        id: 'agent.registration.views.Must be a valid email address',
        defaultMessage: 'Must be a valid email address',
    },
    Required: {
        id: 'agent.registration.views.This is a required field',
        defaultMessage: 'This is a required field.',
    },
    TWIAEmailValidationError: {
        id: 'agent.registration.views.You cannot register individually with TWIA',
        defaultMessage: 'You cannot register individually with TWIA. Please contact your administrator so they can add you to our system.',
    },
    TFPAEmailValidationError: {
        id: 'agent.registration.views.You cannot register individually with TFPA',
        defaultMessage: 'You cannot register individually with TFPA. Please contact your administrator so they can add you to our system.',
    },
    ZIPValidationMessage: {
        id: 'agent.registration.views.Must be a valid Zip Code/postal code',
        defaultMessage: 'Must be a valid Zip Code/postal code',
    },
    PhoneValidationMessage: {
        id:'agent.registration.views.Must be a valid 10-digit phone number',
        defaultMessage: 'Must be a valid 10-digit phone number',
    },
    EmailAddressMatchError: {
        id: 'agent.registration.views.Email addresses must match',
        defaultMessage: 'Email addresses must match',
    },
    
});
